<template>
  <div class="sort-black-chevron-area">
    <select id="contents__sort" v-model="selected" @change="changeOption">
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
      >
        {{ option.key }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    selectedValue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selected: ''
    }
  },
  watch: {
    selectedValue(newValue) {
      if (this.selected !== newValue) {
        this.selected = newValue
      }
    }
  },
  mounted() {
    this.selected = this.selectedValue
  },
  methods: {
    changeOption() {
      this.$emit('change', this.selected)
    }
  }
}
</script>
<style lang="scss" scoped>
.sort-black-chevron-area {
  padding: 4px 0;
}

select {
  cursor: pointer;
  font-weight: bold;
  // NOTE: [iOS対策] iOS では selectタグの font-size が 16px を下回る場合、選択時に該当箇所がズームする仕様になっている
  //       ここでは上記を回避するため font-size を 1.6rem に指定しつつ、 transform: scale(0.75) で 12px に縮める処理を行っている
  font-size: 1.6rem;
  transform: scale(0.75);
  // marginの計算をしやすくするため、左に寄せる。
  transform-origin: left;
  // scaleの関係で全て縮小されるため、px指定のものはfigmaの値÷0.75している
  padding: 20px 66px 20px 21px;
  width: 461.3px;
  height: 61.3px;
  // NOTE: 背景色のだし分けのため、指定が複雑になるので独自にbackground指定をしている
  background: url('../../../../../images/icons/white-chevron-down.svg')
      no-repeat right 17px top 50%,
    linear-gradient(to right, $white 400px, $black 61.3px);
  background-size: 24px 24px, contain;
  border-radius: 5px;
  border: 1.3px solid $gray-2;

  line-height: 1.6;
  color: $black;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
